<template>
  <div class="wim-gallery-container wim-grid">
    <!-- Desktop -->
    <div v-if="$mq !== 'mobile'" v-for="(element, index) in content.content" 
      :key="index" 
      :class="['wim-gallery-element', element.type !== 'legend' ? 'image' :'legend', element.align ? element.align : '']" 
      :style="'grid-column:'+ element.colStart+'/span '+ element.col"
    >
      <!-- Image -->
      <div v-if="element.type === 'image'" :class="['wim-gallery-image']" :style="element.height ? 'padding-top:'+element.height+'%' : ''">
        <img v-lazy="`${baseUrl}images${$mq === 'mobile' ? '-mobile' : ''}/${element.asset}${$retina ? '@2x' : ''}.jpg`" :alt="element.asset">
        <p class="wim-legend-number red">{{element.number}}</p>
      </div>
      <!-- Video -->
      <div v-if="element.type === 'video'" class="wim-gallery-video" ref="galleryVideoContainer">
        <div v-if="element.videoType === 'autoplay'" :class="['wim-toggle-video-audio']" @click="toggleVideoAudio(index)">
          <img :src="`${baseUrl}images/${videoAudio === sectionIndex+''+index ? 'audio-on' : 'audio-off'}.svg`" alt="sound icon">
        </div>
        <video
          class="wim-lazy-video"
          :poster="`${baseUrl}images/${element.asset}${$retina ? '@2x' : ''}.jpg`" 
          :controls="element.videoType === 'controls'"
          :autoplay="element.videoType === 'loop' || element.videoType === 'autoplay'"
          :muted="videoAudio !== sectionIndex+''+index"
          playsinline="true"
          loop="true"
          preload="false"
          style="position: absolute; top:0; width: calc(100% + 4px); left: -2px; max-width: none"
        >
          <source :data-src="`${baseUrl}images/${element.asset}.mp4`" type="video/mp4">
        </video>
        <p class="wim-legend-number red">{{element.number}}</p>
      </div>
      <!-- Legend -->
      <div class="wim-legend" v-if="element.type === 'legend'">
        <ul class="wim-legend element">
          <li v-for="(element, listIndex) in legend" :key="listIndex"><p class="red"><b>{{element.number}} /</b> {{element.dida}}</p></li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash"
import Flickity from "flickity-imagesloaded"
import LazyLoad from 'vanilla-lazyload'

export default {
  props: ["content", "sectionIndex", "videoAudio"],
  data() {
    return {
      baseUrl: process.env.BASE_URL
    };
  },
  mounted() {
    this.$nextTick(() => {
      var myLazyLoad = new LazyLoad({
          elements_selector: ".wim-lazy-video"
      });
    })
  },
  computed: {
    legend() {
      var content = this.content.content;
      var result = [];
      _.forEach(content, element=> {
        if(element.type !== 'legend') {
          result.push({
            "dida" : element.dida,
            "number" : element.number
            })
        }
      })
      return result
    }
  },
  methods: {
    toggleVideoAudio(index) {
      this.$emit('videoAudioToggle', this.sectionIndex+''+index)

      let video = event.target.parentElement.parentElement.querySelector('video');
      video.play();
    },
  }
}
</script>
<style lang="scss" scoped>
@import "../assets/scss/colors.scss";
@import "../assets/scss/fonts.scss";
$gutter: 10px;

.wim-grid {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-column-gap: $gutter;
  grid-row-gap: 10px;
  max-width: 1360px;
  margin:0 auto;
}
.wim-gallery-container {
  margin: 10px 0;
  .wim-gallery-element {
    align-self: end;
    &.legend {
      align-self: center;
    }
    &.start {
      align-self: start;
    }
    .wim-gallery-image,
    .wim-gallery-video {
      height: 0;
      padding-top: 66.66%;
      position: relative;
      overflow: hidden;
      img {
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
      }
      .wim-legend-number {
        position: absolute;
        top:3px;
        left:12px;
        font-size: 14px;
        font-weight: 900;
        margin:0;
      }
    }
    .wim-gallery-video {
      padding-top: 56.25%;
      position: relative;
      overflow: hidden;
      .wim-toggle-video-audio {
        position: absolute;
        bottom: 40px;
        right: 10px;
        z-index: 1;
        width: 25px;
        cursor: pointer;
        img {
          background: transparent;
          width: 100%;
        }
      }
    }
    .wim-legend {
      margin: 0;
      padding: 0;
      list-style: none;
      padding: 0 10px;
      li{
        margin: 10px 0;
      }
      p {
        margin: 0;
        font-size: 13px;
        line-height: 20px;
      }
    }
  }
}
</style>